(function () {
  if (window.__onlineOnlyLabelBound) return;
  window.__onlineOnlyLabelBound = true;

  function getColorName(input) {
    if (!input.id) return '';
    var labelEl = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    if (!labelEl) return '';
    var srOnly = labelEl.querySelector('.sr-only');
    return srOnly ? srOnly.textContent.trim() : labelEl.textContent.trim();
  }

  // オンライン限定（固定文言）
  function syncOnlineOnly(scope, colorName) {
    var label = scope.querySelector('[data-online-only-label]');
    if (!label) return;

    var colors = (label.dataset.onlineOnlyColors || '')
      .split(',')
      .map(function (v) { return v.trim(); })
      .filter(function (v) { return v !== ''; });

    label.hidden = colors.indexOf(colorName) === -1;
  }

  // 個別文言
  function syncExclusive(scope, colorName) {
    var label = scope.querySelector('[data-exclusive-label]');
    if (!label) return;

    var lines = (label.dataset.exclusiveMap || '').split('|');
    var text = '';

    for (var i = 0; i < lines.length; i++) {
      var idx = lines[i].indexOf(':');
      if (idx === -1) continue;
      if (lines[i].slice(0, idx).trim() === colorName) {
        text = lines[i].slice(idx + 1).trim();
        break;
      }
    }

    label.textContent = text;
    label.hidden = text === '';
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.type !== 'radio') return;

    var scope = null;

    // 商品カード
    var swatches = input.closest('[data-online-only-swatches]');
    if (swatches) {
      scope = swatches.closest('product-card');
    } else {
      // 商品ページ（variant-picker）
      var picker = input.closest('variant-picker');
      if (picker) {
        scope = picker.closest('.product-info') || document;
      }
    }

    if (!scope) return;

    var colorName = getColorName(input);
    syncOnlineOnly(scope, colorName);
    syncExclusive(scope, colorName);
  });
})();